import React from 'react';
import { FlattenedMatter } from '../../database/aggregateTypes';
import AddEditMatterForm from './AddEditMatterForm';
import { AddEditMatterFormData } from './types';
import { em, Modal, ScrollArea } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
interface Props {
  matter?: FlattenedMatter;
  initialOverrides?: Partial<AddEditMatterFormData>;
  onClose: () => void;
}

const AddEditMatterModal: React.FC<Props> = (props) => {
  const isMobile = useMediaQuery(`(max-width: ${em(750)})`);

  return (
    <Modal
      size='xl'
      radius='xl'
      fullScreen={isMobile}
      opened={true}
      onClose={props.onClose}
      closeOnClickOutside={false}
      withCloseButton={false}
      scrollAreaComponent={ScrollArea.Autosize}
    >
      <AddEditMatterForm
        matter={props.matter}
        initialOverrides={props.initialOverrides}
        onClose={props.onClose}
      />
    </Modal>
  );
};

export default AddEditMatterModal;
